/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Secondary_Goal_RecompositionInputs */

const en_us2_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lose fat and gain muscle`)
};

const pt_br2_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder gordura e ganhar músculo`)
};

const es_419_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder grasa y ganar músculo`)
};

const pt_pt2_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder gordura e ganhar músculo`)
};

const fr_fr2_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdre du gras et prendre du muscle`)
};

const de_de2_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett verlieren und Muskeln aufbauen`)
};

const it_it2_onboarding_secondary_goal_recomposition = /** @type {(inputs: Onboarding_Secondary_Goal_RecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdere grasso e mettere muscoli`)
};

/**
* | output |
* | --- |
* | "Lose fat and gain muscle" |
*
* @param {Onboarding_Secondary_Goal_RecompositionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_secondary_goal_recomposition = /** @type {((inputs?: Onboarding_Secondary_Goal_RecompositionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Secondary_Goal_RecompositionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_secondary_goal_recomposition(inputs)
	if (locale === "es-419") return es_419_onboarding_secondary_goal_recomposition(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_secondary_goal_recomposition(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_secondary_goal_recomposition(inputs)
	if (locale === "de-DE") return de_de2_onboarding_secondary_goal_recomposition(inputs)
	if (locale === "it-IT") return it_it2_onboarding_secondary_goal_recomposition(inputs)
	return en_us2_onboarding_secondary_goal_recomposition(inputs)
});
export { onboarding_secondary_goal_recomposition as "onboarding.secondary_goal.recomposition" }